import React, { useEffect } from 'react';
import { CloseIcon, DeleteIcon, LoadingSpinner } from '../Icons';
import './index.css'

interface ActionModalProps {
  title: string
  openModal: boolean
  handleCloseModal: any
  handleCreate?: any
  handleEdit?: any
  handleRemove?: any
  removable?: boolean
  mode?: 'create' | 'edit' | 'view'
  setMode?: (p: string) => void
  canEdit?: boolean
  confirmDisabled?: boolean
  loadingChildren?: boolean
  children?: React.ReactNode
}

const ActionModal: React.FC<ActionModalProps> = ({
  title,
  openModal,
  handleCloseModal,
  handleCreate,
  handleEdit,
  handleRemove,
  removable = true,
  mode = 'view',
  setMode,
  canEdit = true,
  confirmDisabled = false,
  loadingChildren = false,
  children }) => {

  const closeModal = () => {
    handleCloseModal()
    setTimeout(() => setMode && setMode('view'), 200)
  }

  const onSave = () => {
    mode === 'create' ? handleCreate && handleCreate() : handleEdit && handleEdit()
  }

  return (
    <React.Fragment>
      <div className={`action-modal-overlay ${openModal ? '' : 'overlay__hidden'}`} />
      <div className={`action-modal ${openModal ? 'visible' : 'hidden'}`}>

        <div className='action-modal-section'>
          <div className='action-modal-title'>
            <span>{title}</span>
            <CloseIcon className='action-modal-close-icon' onClick={closeModal} />
          </div>

          {(loadingChildren) && (
            <div className='action-modal-children__loading'>
              <LoadingSpinner />
            </div>

          )}

          <div className={`action-modal-children ${loadingChildren ? '' : 'show'}`}>
            {children}
          </div>

          {(canEdit || (mode === 'create')) && (
            <div className='action-modal-actions-bar'>
              {(mode === 'view') && (
                <button className='action-modal-edit-btn' onClick={() => setMode && setMode('edit')}>Editar</button>
              )}
              {(removable) && (mode === 'view') && (
                <button className='action-modal-remove-btn' onClick={() => handleRemove && handleRemove()}>
                  <DeleteIcon /> <span>Remover</span>
                </button>
              )
              }

              {(mode === 'edit' || mode === 'create') && (<span>
                <button className='action-modal-cancel-btn' onClick={closeModal}>Cancelar</button>
                <button className='action-modal-save-btn' disabled={confirmDisabled} onClick={onSave}>Confirmar</button>
              </span>)}

            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default ActionModal;